import _Header from '../_app/cuchillo/layout/Header';
import { Power3 } from "gsap";
import { Basics, isTouch } from '../_app/cuchillo/core/Basics';
import { GetBy } from '../_app/cuchillo/core/Element';

export default class Header extends _Header {
  static options = {
    show: {
      duration: .3,
      delay: 0,
      ease: Power3.easeOut
    },
    hide: {
      duration: .3,
      delay: 0,
      ease: Power3.easeIn
    }
  }

  static _activeSubmenu = null;
  static _submenus = [];

  static init() {
    super.init();
    this.blurBG = GetBy.id("Blur");
    this._setupSubmenus();
  }

  static showBlur() {
    this.blurBG.style.visibility = "visible";
  }

  static hideBlur() {
    this.blurBG.style.visibility = "hidden";
  }

  static showNotification() {
    this.container.classList.add('--show-notification');
  }

  static hideNotification() {
    this.container.classList.remove('--show-notification');
  }

  static _setupSubmenus() {
    const items = this.container.querySelectorAll('.has-submenu');

    items.forEach(item => {
      const parent = item.querySelector('.__parent');
      const submenu = item.querySelector('.submenu');

      if (!parent || !submenu) return;

      this._submenus.push({ item, parent, submenu });

      if (isTouch) {
        // Touch: toggle on click
        parent.addEventListener(Basics.clickEvent, (e) => {
          // If it's a link and submenu is open, allow navigation
          if (parent.tagName === 'A' && item.classList.contains('--open')) {
            return;
          }
          e.preventDefault();
          this._toggleSubmenu(item, submenu);
        });
      } else {
        // Desktop: show on hover
        item.addEventListener(Basics.mouseOver, () => {
          this._showSubmenu(item, submenu);
        });

        item.addEventListener(Basics.mouseOut, () => {
          this._hideSubmenu(item, submenu);
        });
      }
    });

    // Close on click outside
    document.addEventListener(Basics.clickEvent, (e) => {
      if (this._activeSubmenu && !this._activeSubmenu.item.contains(e.target)) {
        this._hideSubmenu(this._activeSubmenu.item, this._activeSubmenu.submenu);
      }
    });
  }

  static _toggleSubmenu(item, submenu) {
    if (item.classList.contains('--open')) {
      this._hideSubmenu(item, submenu);
    } else {
      // Close any open submenu first
      if (this._activeSubmenu) {
        this._hideSubmenu(this._activeSubmenu.item, this._activeSubmenu.submenu);
      }
      this._showSubmenu(item, submenu);
    }
  }

  static _showSubmenu(item, submenu) {
    item.classList.add('--open');
    submenu.setAttribute('aria-hidden', 'false');
    this._activeSubmenu = { item, submenu };
  }

  static _hideSubmenu(item, submenu) {
    item.classList.remove('--open');
    submenu.setAttribute('aria-hidden', 'true');
    if (this._activeSubmenu?.item === item) {
      this._activeSubmenu = null;
    }
  }

  static hideAllSubmenus() {
    this._submenus.forEach(({ item, submenu }) => {
      this._hideSubmenu(item, submenu);
    });
  }
}


